export const externalConnectionConfig = {
  installationCallbackUrl: process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/external-oauth-callback` : '',
}

export function validateExternalConfig(): { isValid: boolean; missingVars: string[] } {
  const missingVars: string[] = []
  if (!process.env.REACT_APP_API_URL) {
    missingVars.push('REACT_APP_API_URL')
  }
  return {
    isValid: missingVars.length === 0,
    missingVars,
  }
}
